import './App.css';
import Cover from './components/Cover';
import React, { useEffect, useState } from 'react';
import ApiService from './service/api';
import { Player, Controls } from '@lottiefiles/react-lottie-player';

function App() {

  const [artist, setArtist] = useState({
    name: "",
    url: "",
    cover: "",
    trackName: "",
  });

  const [searching, setSearching] = useState(true);
  const [logged, setLogged] = useState(false);

  useEffect(() => {

    // Get code spotify for request access_token
    let location = window.location.hash;

    if (location != ""){
      let re = /access_token=([^&]*)/ig;
      let reArray = re.exec(location);
      const access_token = reArray[1];
      
      if (access_token) {
        console.log(access_token);
        localStorage.setItem('access_token', access_token);
        setLogged(true);
      }
      
      recommendations();
    }
  }, []);

  function recommendations() {
    
    setSearching(true);
    console.log("Searching on Spotify API...");

    // Remove animation class
    if (document.querySelector('.cover')) {
      document.querySelector('.cover').classList.remove('cover-animate');
    }

    ApiService.get('/recommendations?seed_genres=brazil&market=BR&limit=1')
    .then(res => {
      if (res.status == 401) {
        throw(res.status);
      }else{
        return res.json();
      }
    })
    .then((response) => {
      setArtist({
        name: response.tracks[0].artists[0].name,
        url: response.tracks[0].external_urls.spotify,
        cover: response.tracks[0].album.images[0].url,
        trackName: response.tracks[0].name
      });
      
      // Delay
      setTimeout(() => {
        setSearching(false);
        // Add animation class
        document.querySelector('.cover').classList.add('cover-animate');
      }, 1500);
    })
    .catch(response => {
      console.log(response);
      if (response == '401') {
        setLogged(false);
        setSearching(false);
      }
    });
  }

  return (
    <>
    <div>
      {
        (logged && searching) && <Player autoplay loop src="https://assets6.lottiefiles.com/packages/lf20_h59xofz0.json" style={{ height: '600px', width: '600px' }}></Player>
      }
      {
        (logged && !searching) && <>
                                    <section className="container">
                                      {
                                        (artist.cover) && <Cover coverUrl={artist?.cover} externalUrl={artist?.url} />
                                      }
                                      <aside className="info">
                                        <h1>{ artist?.name }</h1>
                                        <h2>{ artist?.trackName }</h2>
                                      </aside>
                                    </section>

                                    <button onClick={() => recommendations()} className="btn-lucky">I'm lucky</button>
                                  </>
      }

      {
        (!logged) && <a className="btn-authorize" href="https://accounts.spotify.com/authorize?response_type=token&client_id=85bf2a7d9ac849cbab60d66724ab096c&redirect_uri=https://spotifyrandom.netlify.app">Sign account</a>
      }
    </div>
    </>
  );
}

export default App;